import useEightLeggedFreakList from "hooks/useEightLeggedFreakList";
import useEightLeggedFreakNewsCriticsList from "hooks/useEightLeggedFreakNewsCriticsList";
import { useCallback, useMemo } from "react";
const useListButton = ({ serviceName, serviceType }) => {
    const { getList: getReviewsList, isSkipGetList, loading: reviewsLoading } = useEightLeggedFreakList(serviceName);
    const { getNewsCriticsList, loading: newsCriticsLoading } = useEightLeggedFreakNewsCriticsList(serviceName);
    const onClick = useCallback(() => {
        if (serviceType === "reviews" && !isSkipGetList) {
            return getReviewsList();
        }
        if (serviceType === "news") {
            return getNewsCriticsList();
        }
        return undefined;
    }, [getNewsCriticsList, getReviewsList, isSkipGetList, serviceType]);
    const isDisabled = isSkipGetList || reviewsLoading || newsCriticsLoading;
    const loading = reviewsLoading || newsCriticsLoading;
    return useMemo(() => ({
        isDisabled,
        label: "List",
        loading,
        onClick
    }), [isDisabled, loading, onClick]);
};
export default useListButton;
